<template>
  <page-wrapper ref="pageEl" title="รายงานการกดรับ Gift Box">
    <div ref="page-container" class="page-container row">
      <div class="report-filter col-12">
        <div class="form">
          <div class="section">
            <div>
              <div class="label">วันที่ได้รับ MNC</div>
              <date-picker
                v-model="selectedReceiveMncDateRange"
                :disabled="isDropdownDisabled"
                type="daterange"
              ></date-picker>
            </div>
            <div>
              <div class="label">วันที่ได้รับ GB</div>
              <date-picker
                v-model="selectedReceiveGbDateRange"
                :disabled="isDropdownDisabled"
                type="daterange"
              ></date-picker>
            </div>
          </div>

          <div class="section">
            <div>
              <div class="label">โครงการ</div>
              <el-select
                v-model="selectedProject"
                :disabled="isDropdownDisabled"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="(t, idx) in filterProjects"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="label">กิจกรรมที่ได้รับ MNC</div>
              <el-select
                v-model="selectedMncEvent"
                :disabled="isDropdownDisabled"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="(t, idx) in filterMncEvents"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="section">
            <div>
              <div class="label">GB Status</div>
              <el-select
                v-model="selectedGbStatus"
                :disabled="isDropdownDisabled"
                style="width: 100%"
              >
                <el-option
                  v-for="(t, idx) in filterGbStatus"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div style="display: flex; justify-content: center">
            <el-button
              :disabled="isSearchDisabled"
              type="primary"
              @click="handleSearch"
            >
              ค้นหา
            </el-button>

            <el-button
              :disabled="isClickDownloadAsCSVDisabled"
              type="info"
              @click.prevent="downloadFileReport"
            >
              ดาวน์โหลด
            </el-button>

            <el-button
              :disabled="isClearDisabled"
              plain
              type="danger"
              @click="handleClickClear"
            >
              รีเซ็ต
            </el-button>
          </div>
        </div>
      </div>

      <div class="report-content col-12">
        <div>
          <div v-show="latestUpdateTime" class="report-header">
            <div>
              <b>รายงานอัปเดต</b>
              <p>
                {{ latestUpdateMessage() }}
              </p>
            </div>
            <div>
              <div>
                <p>
                  {{ totalCount }}
                </p>
              </div>
              <div align="right">
                <el-button
                  v-for="i in [10, 20, 30]"
                  :key="i"
                  :type="limit == i ? 'primary' : ''"
                  circle
                  size="small"
                  @click="limit = i"
                >
                  {{ i }}
                </el-button>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <DataTable
              :data="reports"
              :headers="headers"
              :loading="tableLoading"
            ></DataTable>
          </div>

          <div class="mt-3" style="text-align: center">
            <el-pagination
              :total="total"
              :disabled="isPaginationDisable"
              :current-page="page"
              :page-size="limit"
              background
              layout="
                prev, pager, next
              "
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { DateTime } from "luxon"
import { backendAdminClient, baanRueJaiClient } from "@/dependencies"
import { formatOrFallbackToInput } from "@/lib/dateTime"

// Components
import PageWrapper from "@/lib/components/PageWrapper"
import DatePicker from "@/lib/components/DatePicker"
import DataTable from "@/lib/components/DataTable"

export default {
  components: {
    PageWrapper,
    DatePicker,
    DataTable,
  },
  data() {
    const filterMncEvents = []
    const filterProjects = []
    const filterGbStatus = [
      { label: "ทั้งหมด", value: undefined },
      { label: "Claimed", value: "CLAIMED" },
      { label: "Pending", value: "PENDING" },
      { label: "Expired", value: "EXPIRED" },
    ]

    const headers = [
      {
        label: "ไอดีลูกค้า",
        value: "user_id",
        width: "90px",
      },
      {
        label: "ชื่อกระเป๋า",
        value: "user_wallet_name",
        width: "80px",
      },
      {
        label: "ชื่อลูกค้า",
        value: "user_fullname",
        width: "160px",
      },
      {
        label: "เบอร์โทรศัพท์",
        value: "user_mobile_no",
        width: "100px",
      },
      {
        label: "อีเมล",
        value: "user_email",
        width: "160px",
      },
      {
        label: "สถานะลูกค้า",
        value: "user_role",
        width: "80px",
      },
      {
        label: "ที่อยู่",
        value: "address_no",
        width: "100px",
      },
      {
        label: "รหัสโครงการ",
        value: "project_code",
        width: "100px",
      },
      {
        label: "รหัสพนักงาน",
        value: "employee_id",
        width: "100px",
      },
      {
        label: "วันที่ได้รับ GB",
        value: "created_at",
        width: "100px",
      },
      {
        label: "สถานะ GB",
        value: "status",
        width: "100px",
      },
      {
        label: "วันที่ GB หมดอายุ",
        value: "expired_at",
        width: "100px",
      },
      {
        label: "Event ที่ได้รับ GB",
        value: "gift_box_name",
        width: "200px",
      },
      {
        label: "วันที่ได้รับ MNC",
        value: "claimed_at",
        width: "100px",
      },
      {
        label: "จำนวนที่ได้รับ MNC (MNC)",
        value: "total_coin",
        width: "120px",
      },
      {
        label: "จำนวนได้รับ MNC (บาท)",
        value: "total_coin_baht",
        width: "110px",
      },
      {
        label: "Event ที่ได้รับ MNC",
        value: "mnc_event_name",
        width: "200px",
      },
      {
        label: "ปีของ MNC ที่ได้รับ",
        value: "mnc_effective_date",
        width: "110px",
      },
      {
        label: "MNC Expired",
        value: "mnc_expiry_date",
        width: "110px",
      },
      {
        label: "Transaction Status",
        value: "transaction_status",
        width: "120px",
      },
    ]

    const selectInputFilter = {
      filterMncEvents,
      filterProjects,
      filterGbStatus,
      selectedReceiveMncDateRange: [],
      selectedReceiveGbDateRange: [],
      selectedProject: undefined,
      selectedMncEvent: undefined,
      selectedGbStatus: undefined,
    }

    const isDisabledInput = {
      isDropdownDisabled: false,
      isSearchDisabled: false,
      isClickDownloadAsCSVDisabled: false,
      isClearDisabled: false,
      isPaginationDisable: false,
    }

    const pagination = {
      page: 1,
      limit: 10,
      total: 0,
      latestUpdateTime: "",
    }

    return {
      ...isDisabledInput,
      ...selectInputFilter,
      ...pagination,
      tableLoading: false,
      reports: [],
      headers,
    }
  },
  computed: {
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล"
      }

      const { limit } = this
      const { total } = this
      const currentTotalItem = this.reports.length

      const isLastPage = limit > currentTotalItem
      const currentPage = +this.page || 1

      const endNumber = isLastPage ? total : currentPage * limit

      const startNumber = isLastPage
        ? limit * (currentPage - 1) + 1
        : endNumber - limit + 1

      const safeStartNumber = startNumber > 0 ? startNumber : 1

      const totalStr = total.toLocaleString()
      const startStr = safeStartNumber.toLocaleString()
      const endStr = endNumber.toLocaleString()

      return `แสดงผล ${startStr} - ${endStr} จากทั้งหมด ${totalStr}`
    },
    queryParams() {
      const {
        selectedReceiveMncDateRange,
        selectedReceiveGbDateRange,
        selectedProject,
        selectedMncEvent,
        selectedGbStatus,
        page,
        limit,
      } = this.$route.query
      return {
        mnc_received_date: this.convertDateRange(selectedReceiveMncDateRange),
        gb_received_date: this.convertDateRange(selectedReceiveGbDateRange),
        project_code: selectedProject,
        mnc_event: selectedMncEvent,
        gb_status: selectedGbStatus,
        page: (page && +page) || 1,
        limit: +limit || this.limit,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
    async limit(from, to) {
      if (from !== to) {
        await this.handleSearch()
      }
    },
  },
  created() {
    this.getProjectFilterList()
    this.getMNCEventFilterList()
    this.setupData()
  },
  methods: {
    setupData() {
      this.queryBuilder()
      this.fetchReports()
    },
    queryBuilder() {
      const {
        selectedReceiveMncDateRange,
        selectedReceiveGbDateRange,
        selectedProject,
        selectedMncEvent,
        selectedGbStatus,
        page,
        limit,
      } = this.$route.query
      this.selectedReceiveMncDateRange = this.setupQueryDateRange(
        selectedReceiveMncDateRange,
      )
      this.selectedReceiveGbDateRange = this.setupQueryDateRange(
        selectedReceiveGbDateRange,
      )
      this.selectedProject = selectedProject || null
      this.selectedMncEvent = selectedMncEvent || null
      this.selectedGbStatus = selectedGbStatus || null
      this.page = (page && +page) || 1
      this.limit = +limit || this.limit
    },
    handleSearch() {
      const {
        selectedReceiveMncDateRange,
        selectedReceiveGbDateRange,
        selectedProject,
        selectedMncEvent,
        selectedGbStatus,
        limit,
      } = this

      let query = {
        selectedReceiveMncDateRange: this.convertDateRange(
          selectedReceiveMncDateRange,
        ),
        selectedReceiveGbDateRange: this.convertDateRange(
          selectedReceiveGbDateRange,
        ),
        selectedProject,
        selectedMncEvent,
        selectedGbStatus,
        limit,
        page: 1,
      }
      // NOTE: filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(
          ([, value]) => value !== null && value !== "",
        ),
      )
      // NOTE: replace route with query string
      const route = {
        name: this.$route.name,
        query,
      }
      this.$router.replace(route)
    },
    setupQueryDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        const [from, to] = dateRange
        return [DateTime.fromISO(from), DateTime.fromISO(to)]
      }
      return []
    },
    convertDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        return dateRange.map((date) => DateTime.fromISO(date).toISO())
      }
      return null
    },
    handleClickClear() {
      const route = {
        name: this.$route.name,
      }
      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: (page && +page) || 1 },
      }
      this.$router.replace(route)
    },
    async fetchReports() {
      // Disable button while downloading
      this.tableLoading = true
      this.isDisableButton()

      // Initial Default
      let latestUpdate = DateTime.utc()
      let reports = []
      let total = 0

      try {
        const query = this.queryParams
        const response =
          await backendAdminClient.report.getGiftBoxReports(query)

        // Validate Response
        if (response) {
          const { result } = response.data

          reports = result.reports
          total = result.pagination.total_records
          latestUpdate = result.timestamp
        }

        // Set Report
        this.reports = reports
        this.total = total
        this.latestUpdateTime = latestUpdate
      } catch (error) {
        const errorMessage = error.response
          ? error.response.data.message || "ไม่สามารถดึงข้อมูลได้"
          : "เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์"

        this.$message.error(errorMessage)
      } finally {
        this.isAbleButton()
        this.tableLoading = false
      }
    },
    async downloadFileReport(event) {
      // get date format 2025-05-19-120000
      const dateFilename = DateTime.utc()
        .setZone("Asia/Bangkok")
        .toFormat("yyyy-MM-dd-HHmmss")

      // Init file name for download report
      const fileName = `${dateFilename}-mnc-gift-box-reports.xlsx`
      event.preventDefault()

      // Disable button while downloading
      this.isDisableButton()

      // Init request params
      /* eslint-disable camelcase -- API query params */
      const {
        mnc_received_date,
        gb_received_date,
        project_code,
        mnc_event,
        gb_status,
      } = this.queryParams

      const query = {
        mnc_received_date,
        gb_received_date,
        project_code,
        mnc_event,
        gb_status,
      }
      /* eslint-enable camelcase */

      // Send request
      const response =
        await backendAdminClient.report.downloadGiftBoxReports(query)

      // check response before download
      if (response.data) {
        const blob = new Blob([response.data])
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
      }

      // Re-enable button after download
      this.isAbleButton()
    },
    isDisableButton() {
      this.isSearchDisabled = true
      this.isClearDisabled = true
      this.isClickDownloadAsCSVDisabled = true
      this.isPaginationDisable = true
      this.isDropdownDisabled = true
    },
    isAbleButton() {
      this.isSearchDisabled = false
      this.isClearDisabled = false
      this.isClickDownloadAsCSVDisabled = false
      this.isPaginationDisable = false
      this.isDropdownDisabled = false
    },
    formatDateToTH(date, format) {
      return formatOrFallbackToInput(date, format)
    },
    latestUpdateMessage() {
      const format = "dd MMMM yyyy เวลา HH:mm น."
      return this.formatDateToTH(this.latestUpdateTime, format)
    },
    async getProjectFilterList() {
      // Default Project
      const initialList = [{ label: "ทั้งหมด", value: undefined }]

      try {
        const response = await baanRueJaiClient.admin.projects.list()

        if (response) {
          const result = response.data

          const mappingList = result.map((item) => ({
            label: `${item.projectName} (${item.projectCode})`,
            value: item.projectCode,
          }))

          // Set State
          this.filterProjects = initialList.concat(mappingList)
        }
      } catch (error) {
        this.filterProjects = initialList
        this.$message.error("ไม่สามารถโหลดรายชื่อโครงการได้")
      }
    },
    async getMNCEventFilterList() {
      // Default MNC Event
      const initialList = [{ label: "ทั้งหมด", value: undefined }]

      try {
        const response = await backendAdminClient.report.getMncEvents()

        // Validate Response
        if (response) {
          const { result } = response.data

          const mappingList = result.map((item) => ({
            label: item.mnc_event_name,
            value: item.mnc_event,
          }))

          // Set State
          this.filterMncEvents = initialList.concat(mappingList)
        }
      } catch (error) {
        this.filterMncEvents = initialList
        this.$message.error("ไม่สามารถโหลดรายการ MNC Event ได้")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  z-index: 1;
}

.page-container {
  padding: 15px;
}

.report-cell {
  a {
    text-decoration: underline;
  }

  padding: 5px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);

  &:empty::before {
    content: "N/A";
    color: #d8d8d8;
  }
}

.page-container {
  padding: 1rem;
  margin: 0;
}

.report-filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.report-filter .form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  margin-top: 15px;
  grid-template-columns: repeat(2, 1fr);
}

.form .section[col="3"] {
  grid-template-columns: repeat(3, 1fr);
}

.label {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.report-content .report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 640px) {
  .form .section,
  .form .section[col="3"] {
    grid-template-columns: 1fr;
  }

  .report-filter {
    margin-bottom: 1rem;
  }
}

.el-input__inner {
  text-align: center;
}

.el-date-editor--daterange,
.el-input__inner {
  width: 100%;
}
</style>
